<div mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.eu-kuluttajamyynti.otsikko' | translate | async }}
  </lemon-dialog-header>
  <div class="kappaleet">
    <p>{{ 'lasku.eu-kuluttajamyynti.johdanto' | translate | async }}</p>
    <div>
      <div class="kappaleen-otsikko">{{ 'lasku.eu-kuluttajamyynti.alle-rajan-otsikko' | translate | async }}</div>
      <p>{{ 'lasku.eu-kuluttajamyynti.alle-rajan' | translate | async }}</p>
    </div>
    <div>
      <div class="kappaleen-otsikko">{{ 'lasku.eu-kuluttajamyynti.yli-rajan-otsikko' | translate | async }}</div>
      <p>{{ 'lasku.eu-kuluttajamyynti.yli-rajan' | translate | async }}</p>
    </div>
    <div>
      <div class="kappaleen-otsikko">{{ 'lasku.eu-kuluttajamyynti.rajaan-lasketaan-otsikko' | translate | async }}</div>
      <p>{{ 'lasku.eu-kuluttajamyynti.rajaan-lasketaan' | translate | async }}</p>
    </div>
    <p>{{ 'lasku.eu-kuluttajamyynti.erityisjarjestelma' | translate | async }}</p>
    <p>{{ 'lasku.eu-kuluttajamyynti.kirjanpitaja' | translate | async }}</p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button class="secondarybutton" mat-button mat-dialog-close>{{ 'yleiset.sulje' | translate | async }}</button>
</div>
